import React from 'react'
import { Checkbox, withStyles } from '@material-ui/core'
import colors from '../../assets/colors'

export const CustomCheckbox = withStyles(theme => ({
  root: {
    padding: 0,
    width: 20,
    height: 20,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  colorSecondary: {
    color: theme.palette.grey[400],
    '&$checked': {
      color: colors.primary,
    },
    '&$disabled': {
      color: theme.palette.grey[300],
    },
  },
  checked: {},
  disabled: {},
}))(({ classes, disabled, ...props }) => {
  const disabledIcon = (
    <span
      style={{
        width: 20,
        height: 20,
        borderRadius: 6,
        backgroundColor: colors.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${colors.primary}`,
      }}
    >
      <svg
        width="10"
        height="2"
        viewBox="0 0 10 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1H9" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </span>
  )

  return (
    <Checkbox
      disableRipple
      checkedIcon={
        <span
          style={{
            width: 20,
            height: 20,
            borderRadius: 4,
            backgroundColor: colors.primary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${colors.primary}`,
          }}
        >
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 5L4.5 8.5L11 1"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      }
      icon={
        disabled ? (
          disabledIcon
        ) : (
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: 4,
              border: `1px solid ${colors.grayMedium}`,
              backgroundColor: 'white',
            }}
          />
        )
      }
      classes={{
        root: classes.root,
        colorSecondary: classes.colorSecondary,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      disabled={disabled}
      color="secondary"
      {...props}
    />
  )
})
